import { HomeOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Form, FormInstance, Input, Modal, Select } from "antd";
import "./spareparts_master.css";
import { withSparePartsTableLogic } from "../../components/hoc_spareparts_master";
import { BiListUl } from "@react-icons/all-files/bi/BiListUl";
import AddItemClass from "../inquiry/add_item_class";
import { ItemClassDataType as AddItemClassDataType } from '../inquiry/add_item_class';
import AddModel from "../inquiry/add_model";
import { ModelDataType } from "../inquiry/add_model";
import LocationCodeRack from "./location_code_rack";
import { FaPlusCircle } from "react-icons/fa";
import { HiOutlineDocumentCheck } from "react-icons/hi2";

interface SparePartsProps {
    form: FormInstance;
    itemClassOptions: { value: string; label: string }[];
    itemBrandOptions: { value: string; label: string }[];
    statusOptions: { value: number; label: string }[];
    handleSaveOrUpdate: () => void;
    isAddItemClassModalVisible: boolean;
    showAddItemClassModal: () => void;
    handleAddItemClassModalCancel: () => void;
    handleItemClassSelect?: (selectedClass: AddItemClassDataType) => void;
    isUpdateMode: boolean;
    selectedItemClassDescription: string | null;
    handleAddToStock: () => void;
    selectedLocationRackCode: string | null;
    handleNew: () => void;
    isStockDuplicate: boolean;
    isAddModelModalVisible: boolean;
    showAddModelModal: () => void;
    handleAddModelModalCancel: () => void;
    handleModelSelect: (selectedModel: ModelDataType) => void;
    selectedModelDescription: string | null;
    isLocationRackModalVisible: boolean;
    showLocationRackModal: () => void;
    handleLocationRackModalCancel: () => void;
    handleLocationRackSelect: (selectedRackCode: string) => void;
    isProcessing: boolean;
}

const SpareParts: React.FC<SparePartsProps> = ({
    form,
    itemBrandOptions,
    statusOptions,
    handleSaveOrUpdate,
    handleAddToStock,
    isAddItemClassModalVisible,
    showAddItemClassModal,
    handleAddItemClassModalCancel,
    isUpdateMode,
    handleItemClassSelect,
    selectedItemClassDescription,
    selectedLocationRackCode,
    handleNew,
    isStockDuplicate,
    isAddModelModalVisible,
    showAddModelModal,
    handleAddModelModalCancel,
    handleModelSelect,
    selectedModelDescription,
    isLocationRackModalVisible,
    showLocationRackModal,
    handleLocationRackModalCancel,
    handleLocationRackSelect,
    isProcessing
}) => {
    const Submitbtn = HiOutlineDocumentCheck as React.ComponentType<any>;
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };


    return (

        <div id="iklk" style={transformStyle}>
            <div className="gjs-grid-row" id="i4t51">
                <div className="gjs-grid-column" id="ibwbi">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/spareparts_master",
                                title: (
                                    <>
                                        <span>Data SpareParts</span>
                                    </>
                                ),
                            },
                            {
                                href: "#/dashboard/browser_data_spareparts",
                                title: (
                                    <>
                                        <span>Browser Data Spareparts</span>
                                    </>
                                ),
                            },
                            {
                                href: "#/dashboard/status_import_spareparts_master",
                                title: "Status Update Data Sparepart Master",
                            },
                        ]}
                    />
                </div>
            </div>

            <div className="gjs-grid-row" id="il3t3">
                <div className="gjs-grid-column" id="ipuub">
                    <Button className="gr-button" onClick={handleNew} loading={isProcessing} disabled={isProcessing}>
                        <FaPlusCircle style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        New
                    </Button>
                    <Button className="gr-button" onClick={handleSaveOrUpdate} loading={isProcessing} disabled={isProcessing}>
                        <Submitbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        {isUpdateMode ? "Update" : "Submit"}
                    </Button>
                    <Button className="gr-button" onClick={handleAddToStock} disabled={isStockDuplicate || isProcessing} loading={isProcessing}>
                        <Submitbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Add to Stock
                    </Button>
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 480, marginTop: 20 }}
                        labelCol={{ style: { width: '180px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                    >
                        <Form.Item
                            label="Status"
                            name="status"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Required!',
                                },
                            ]}
                        >
                            <Select
                                placeholder="Select Status"
                                options={statusOptions}
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Brand"
                            name="brand"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Required!',
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                placeholder="Select Item Brand"
                                optionFilterProp="label"
                                options={itemBrandOptions}
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Model"
                            name="model"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Required!',
                                },
                            ]}

                        >
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <Input
                                    style={{ width: "100%" }}
                                    value={selectedModelDescription || ''}
                                />
                                <Button
                                    id="add_model"
                                    type="primary"
                                    icon={
                                        <BiListUl style={{ width: "40px", height: "20px" }} />
                                    }
                                    onClick={showAddModelModal}
                                />
                            </div>
                        </Form.Item>
                        <Form.Item
                            label="Item Code"
                            name="item_code"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Required!',
                                },
                            ]}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Item Code I"
                            name="item_code1"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Item Code II"
                            name="item_code2"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Item Name"
                            name="item_name"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Required!',
                                },
                            ]}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Item Class"
                            name="item_class"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Required!',
                                },
                            ]}
                        >
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <Input
                                    style={{ width: "100%" }}
                                    value={selectedItemClassDescription || ''}
                                    readOnly
                                />
                                <Button
                                    id="add_item_class"
                                    type="primary"
                                    icon={
                                        <BiListUl style={{ width: "40px", height: "20px" }} />
                                    }
                                    onClick={showAddItemClassModal}
                                />
                            </div>
                        </Form.Item>
                        <Form.Item
                            label="Location Code Rack"
                            name="location_code_rack"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Required!',
                                },
                            ]}
                        >
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <Input
                                    style={{ width: "100%" }}
                                    value={selectedLocationRackCode || ''}
                                    readOnly
                                />
                                <Button
                                    id="location_code_rack"
                                    type="primary"
                                    icon={
                                        <BiListUl style={{ width: "40px", height: "20px" }} />
                                    }
                                    onClick={showLocationRackModal}
                                />
                            </div>
                        </Form.Item>
                        <Form.Item
                            label="UoM"
                            name="uom"
                            style={{
                                marginBottom: "5px", width: "48%"
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="UoM Rate"
                            name="uom_rate"
                            style={{
                                marginBottom: "5px", width: "48%"
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Remark"
                            name="remark"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Required!',
                                },
                            ]}
                        >
                            <Input.TextArea placeholder="" rows={5} />
                        </Form.Item>
                        <Form.Item
                            label="Warehouse"
                            name="warehouse"
                            style={{
                                marginBottom: "5px", width: "100%"
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                    </Form>

                </div>
            </div>
            <Modal
                title="List Item Class"
                open={isAddItemClassModalVisible}
                onCancel={handleAddItemClassModalCancel}
                footer={null}
                width={450}
                destroyOnClose
            >
                {handleItemClassSelect && <AddItemClass onSelectItemClass={handleItemClassSelect} />}
            </Modal>
            <Modal
                title="List Model"
                className="add-modal"
                open={isAddModelModalVisible}
                onCancel={handleAddModelModalCancel}
                footer={null}
                width={450}
                destroyOnClose
            >
                <AddModel onModelSelect={handleModelSelect} onCancel={handleAddModelModalCancel} />
            </Modal>
            <Modal
                title="List Location Code Rack"
                open={isLocationRackModalVisible}
                onCancel={handleLocationRackModalCancel}
                footer={null}
                width={450}
                destroyOnClose
            >
                <LocationCodeRack onSelectRack={handleLocationRackSelect} />
            </Modal>
        </div>
    );
};

export default withSparePartsTableLogic(SpareParts);